import Tabs from '../helpers/Tabs';
import '../helpers/functions';

$(document).ready(function () {
    if ($('.tabs').length)
        Tabs.i($('.tabs'), $('.tabs-head'), $('.tabs-head-preview'));
});